import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { Link } from "../../library/link";
const selectorId = "inspiration-base-selector";
export const InspirationBaseSelector = (props)=>{
    const { activeBase: active, routePath, labels } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: `tabs`,
        id: selectorId,
        children: /*#__PURE__*/ _jsxs("ul", {
            className: "tabs__list",
            children: [
                /*#__PURE__*/ _jsx("li", {
                    className: `tabs__item ${active == 'book' ? 'active' : 'inactive'}`,
                    children: /*#__PURE__*/ _jsxs(Link, {
                        className: "tabs__link",
                        url: `/${routePath}/boek`,
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                className: "tabs__icon",
                                width: "24",
                                height: "24",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--book-open"
                                })
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "tabs__label",
                                children: labels.book
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    className: `tabs__item ${active == 'theme' ? 'active' : 'inactive'}`,
                    children: /*#__PURE__*/ _jsxs(Link, {
                        className: "tabs__link",
                        url: `/${routePath}/thema`,
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                className: "tabs__icon",
                                width: "22px",
                                height: "22px",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--tag"
                                })
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "tabs__label",
                                children: labels.theme
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    className: `tabs__item ${active == 'mood' ? 'active' : 'inactive'}`,
                    children: /*#__PURE__*/ _jsxs(Link, {
                        className: "tabs__link",
                        url: `/${routePath}/stemming`,
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                className: "tabs__icon",
                                width: "23px",
                                height: "22px",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--smile"
                                })
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "tabs__label",
                                children: labels.mood
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export const inspirationLabelsWeb = {
    book: 'Aanraders',
    theme: 'Onderwerp',
    mood: 'Sfeer en emotie',
    location: 'Locaties',
    moodgroup: 'Sfeergroepen'
};
export const inspirationLabelsKiosk = {
    book: 'Meer boeken zoals...',
    theme: 'Zoek op onderwerp',
    mood: 'Zoek op sfeer of emotie',
    location: 'Locaties',
    moodgroup: 'Sfeergroepen'
};
